import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL;

export default function MFDForgotPassword() {
  const [identifier, setIdentifier] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/api/auth/mfd/forgot-password`,
        identifier.includes('@') ? { email: identifier.trim().toLowerCase() } : { mfd_code: identifier.trim() });
    } catch {
      // intentionally ignored — always show the same generic confirmation
    } finally {
      setLoading(false);
      setSubmitted(true);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.header}>
          <div style={styles.logo}>FIP</div>
          <h1 style={styles.title}>MFD Password Help</h1>
          <p style={styles.subtitle}>Locked out? Request a password reset.</p>
        </div>
        {submitted ? (
          <div style={styles.confirm}>
            If that account exists, a new password has been sent to the registered email address.
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={styles.form}>
            <div style={styles.field}>
              <label style={styles.label}>Email or MFD Code</label>
              <input type="text" value={identifier} onChange={e => setIdentifier(e.target.value)}
                style={styles.input} placeholder="Email or MFD Code (e.g. RMF001)" required />
            </div>
            <button type="submit" style={styles.button} disabled={loading}>
              {loading ? 'Submitting...' : 'Reset Password'}
            </button>
          </form>
        )}
        <p style={styles.backLink}>
          <button type="button" onClick={() => navigate('/login')} style={styles.backBtn}>Back to Login</button>
        </p>
        <p style={styles.footer}>Fund Intelligence Platform © 2026</p>
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', background: 'linear-gradient(135deg, #1565C0 0%, #0D47A1 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Segoe UI', sans-serif" },
  card: { background: '#fff', borderRadius: '12px', padding: '48px 40px', width: '100%', maxWidth: '420px', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' },
  header: { textAlign: 'center', marginBottom: '32px' },
  logo: { background: '#1565C0', color: '#fff', width: '56px', height: '56px', borderRadius: '12px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', fontWeight: 'bold', marginBottom: '16px' },
  title: { fontSize: '20px', color: '#1565C0', margin: '0 0 8px', fontWeight: '700' },
  subtitle: { color: '#666', margin: 0, fontSize: '14px' },
  form: { display: 'flex', flexDirection: 'column', gap: '20px' },
  field: { display: 'flex', flexDirection: 'column', gap: '6px' },
  label: { fontSize: '13px', fontWeight: '600', color: '#333' },
  input: { padding: '12px 14px', border: '1.5px solid #ddd', borderRadius: '8px', fontSize: '14px', outline: 'none' },
  button: { background: '#1565C0', color: '#fff', border: 'none', borderRadius: '8px', padding: '14px', fontSize: '15px', fontWeight: '600', cursor: 'pointer', marginTop: '8px' },
  confirm: { background: '#e8f5e9', color: '#2e7d32', padding: '16px', borderRadius: '8px', fontSize: '14px', border: '1px solid #c8e6c9', textAlign: 'center' },
  backLink: { textAlign: 'center', margin: '16px 0 0' },
  backBtn: { background: 'none', border: 'none', color: '#1565C0', fontSize: '13px', cursor: 'pointer', padding: 0, textDecoration: 'underline' },
  footer: { textAlign: 'center', color: '#aaa', fontSize: '12px', marginTop: '24px' },
};
